import { makeStyles } from "@mui/styles"
import { Theme } from "@mui/material"

export const SwitchTextStyles = makeStyles((theme: Theme) => ({
  switchTextWrapper: {
    border: "2px solid #749DF8",
    height: "30px",
    borderRadius: "14px",
    display: "inline-block",
    paddingRight: "10px",
  },
  fullHeight: {
    height: "100%",
  },
  title: {
    paddingLeft: "5px",
    fontSize: "14px",
    height: "30px",
    lineHeight: "30px",
  },
  aligner: {
    justifyContent: "center",
  },
}))
